import { observer } from 'mobx-react-lite';
import { DATA } from '../../game/data';
import { Popup } from './Reusable/Popup';
import { ProgressBar } from './Reusable/ProgressBar';
import { GreenButton } from './Reusable/GreenButton';
import { IMAGES } from '../../game/data/images';
import { COLORS } from '../../game/data/colors';
import { formatNumber } from '../../game/helpers';

export const AdvancePopup: React.FC = observer(() => {
  if (DATA.openPopup !== 'advance') {
    return null;
  }

  const onAdvanceClick = () => {
    DATA.advance();
  };

  const renderContent = () => {
    const currentAdvance = DATA.currentAdvanceData;

    const nextAdvance = DATA.nextAdvanceData;
    const percentage = DATA.transportedPassangers / nextAdvance.requiredPassengers;
    const canAdvance = percentage >= 1;

    return (
      <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
          <h2>x{currentAdvance.multiplier}</h2>
          <img src={IMAGES.ICONS.arrow_right} alt="arrow" style={{ width: '2rem' }} />
          <h2 style={{ color: COLORS.green_500 }}>x{nextAdvance.multiplier}</h2>
        </div>
        <div className="tooltip-text" style={{ marginBottom: 16 }}>
          Airplane and lounge ticket price multiplier
        </div>
        <div>
          <ProgressBar fill={percentage} height={12} />
          <div className="tooltip-text" style={{ marginTop: 4 }}>
            Transported passengers: {formatNumber(DATA.transportedPassangers)}/{formatNumber(nextAdvance.requiredPassengers)}
          </div>
        </div>
        {canAdvance && (
          <div style={{ marginTop: 16 }}>
            <GreenButton onClick={onAdvanceClick} style={{ padding: '8px 16px' }}>
              Advance
            </GreenButton>
            <div className="tooltip-text" style={{ marginTop: 8 }}>
              You will start from scratch, but with much more expensive tickets!
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Popup
      width={300}
      onClose={() => {
        DATA.setOpenPopup(null);
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ marginBottom: 16 }}>Advance</h1>
        {renderContent()}
      </div>
    </Popup>
  );
});
